import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ARService} from '../../ar.service';
import {DataARClaimModel} from '../../../../models/accountsReceivable/data-ar-claim.model';
import {DataARTransactionItemModel} from '../../../../models/accountsReceivable/data-ar-transaction-item.model';
import {DataARLedgerModel} from '../../../../models/accountsReceivable/data-ar-ledger.model';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import {PatientDataModel} from '../../../../models/patient/patient-data.model';
import {CreateClaimsModel} from '../../models/create-claims.model';
import {ToothPickerComponent} from '../../../tdo-shared/tooth-picker/tooth-picker.component';
import {ArCreateTransactionComponent} from '../../fee-calculation/ar-create-transaction/ar-create-transaction.component';
import {DoctorByTDOCIDModel} from '../../models/doctor-by-tdocid.model';
import {SalutationEnum} from '../../../../models/enum/salutation.enum';
import {ClaimTypeEnum} from '../../../../models/enum/claim-type.enum';
import {ToothPickerConfigModel} from '../../../tdo-shared/tooth-picker/tooth-picker-config.model';
import {DataARLedgerListModel} from '../../models/data-ar-ledger-list.model';
import {Globals} from '../../../../globals';
import {DataARClaimListModel} from '../../models/data-ar-claim-list';
import {ClaimViewComponent} from '../claim-view/claim-view.component';
import {InsuranceTransactionItemsModel} from '../../models/insurance-transaction-items.model';
import {Constants} from '../../../../constants';
import {ClaimStatusEnum} from '../../../../models/enum/claim-status.enum';
import {InsuranceService} from '../../../insurance/insurance.service';
import {MatSelectChange} from '@angular/material/select';
import { TdoClientConfigurationModel } from 'src/app/models/clients/tdo-client-configuration.model';
import {dataPatientInsurance} from '../../_models/ar.models';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-claim-wizard',
  templateUrl: './claim-wizard.component.html',
  styleUrls: ['./claim-wizard.component.css']
})
export class ClaimWizardComponent implements OnInit {

  LOCID: number;
  isLoading: boolean = false;
  PatientId: string = '';
  // dataTransactionItems: DataARTransactionItemModel[] = [];
  dataPatientInsuranceList: dataPatientInsurance[] = [];
  dataTransactionItemsByInsurance: InsuranceTransactionItemsModel[] = [];
  dataTransactionItemsByInsuranceMaster: InsuranceTransactionItemsModel[] = [];
  dataTransactionItems: DataARTransactionItemModel[] = [];
  dataTransactionItemsRealClaims: DataARTransactionItemModel[] = [];
  dataTransactionItemsSecondary: DataARTransactionItemModel[] = [];
  dataTransactionItemsPredetermination: DataARTransactionItemModel[] = [];
  postedTransactionItems: DataARTransactionItemModel[] = [];
  // ledgerItems: DataARLedgerModel[] = [];
  ledgerListItems: DataARLedgerListModel[] = [];
  PatientInsuranceID: string;
  claimTypes: EnumValidValueItemModel[] = [];
  selectedClaimType: string =  ClaimTypeEnum.RealClaim;
  dataPatient: PatientDataModel;
  selectedPatientInsuranceId: string;
  doctors: DoctorByTDOCIDModel[] = [];
  InsuranceSelectionList: InsuranceTransactionItemsModel[] = [];
  selectedInsuranceSelection: string = Constants.emptyGuid;
  patientClaims: DataARClaimListModel[] = [];
  emptyGuid: string = Constants.emptyGuid;
  enumARItemStatusPosted: string = '00000077-1000-0000-0000-000000000002';
  isPrimarySelected: boolean = true;
  cfgTDOClient: TdoClientConfigurationModel[] = [];
  isInsuranceEstimating: boolean = false;

  enumClaimCheckStatusNotChecked: string = '00000208-1000-0000-0000-000000000001';
  enumLedgerItemStatusVoid: string = '00000083-1000-0000-0000-000000000003';
  //enumLedgerItemStatusPaid: string = '00000083-1000-0000-0000-000000000002';
  enumLedgerItemStatusOutstanding: string = '00000083-1000-0000-0000-000000000001';
  showZeroInsurance: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ClaimWizardComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar,
    private arService: ARService,
    private dialog: MatDialog,
    public globals: Globals,
    private insuranceService: InsuranceService,
    private datePipe: DatePipe,
  ) {
    console.log(this.data);
    this.LOCID = parseInt(localStorage.getItem('LOCID'));
    this.PatientId = this.data.PatientId;

    // all data should be coming from the server
    // if (this.data.dataLedgerItems) { this.ledgerListItems = this.data.dataLedgerItems.filter(x => x.enumLedgerItemStatusID !== this.enumLedgerItemStatusVoid); }
    // if (this.data.dataTransactionItems)
    // {
    //   console.log('this.data.dataTransactionItems:', this.data.dataTransactionItems);
    //   this.dataTransactionItems = this.data.dataTransactionItems;
    //   this.dataTransactionItemsSecondary = this.data.dataTransactionItems;
    // }
    // if (this.postedTransactionItems) {this.postedTransactionItems = this.data.postedTransactionItems; }
    // if (this.data.doctors) { this.doctors = this.data.doctors; }
    // if (this.data.selectedClaimType) { this.selectedClaimType = this.data.selectedClaimType; }
  }

  async ngOnInit() {

    await this.init();

    // all data should be coming from the server
    // // if ledger items passed, loop through and copy transaction items
    // if (this.ledgerListItems) {
    //
    //
    //   this.ledgerListItems.forEach(ledgerItem => {
    //     // if transaction item not already added, add
    //     if (this.dataTransactionItems.filter(a => ledgerItem.ARTransactionItemID === a.ARTransactionItemID).length === 0) {
    //       // if data
    //       this.dataTransactionItems.push(ledgerItem.dataARTransactionItemList);
    //     }
    //     // if transaction item not already added, add
    //     if (this.dataTransactionItemsSecondary.filter(a => ledgerItem.ARTransactionItemID === a.ARTransactionItemID).length === 0) {
    //       // if data
    //       this.dataTransactionItemsSecondary.push(ledgerItem.dataARTransactionItemList);
    //     }
    //   });
    // }

    // // filter out $0 insurance if needed
    // if (!this.showZeroInsurance) {
    //   this.dataTransactionItems = this.dataTransactionItems.filter(a => a.InsuranceAmount > 0);
    //   this.dataTransactionItemsSecondary = this.dataTransactionItemsSecondary.filter(a => a.InsuranceAmount > 0);
    // }

    // insurance ddl
    this.insuranceService.getPatientInsuranceList(this.globals.currentPatientId)
      .subscribe(response => {
        response.forEach(a => {
          if (!a.isDefault) {
            const insurance = new InsuranceTransactionItemsModel();
            insurance.PatientInsuranceID = a.PatientInsuranceID;
            insurance.InsuranceName = a.Description;
            insurance.PatientInsurancePrimary = a.InsuranceOrder === 0 ? true : false;
            this.InsuranceSelectionList.push(insurance);
          }
        });

        if (this.InsuranceSelectionList.length > 0) {
          this.selectedPatientInsuranceId = this.InsuranceSelectionList[0].PatientInsuranceID;
          this.selectedInsuranceSelection = this.selectedPatientInsuranceId;
        }

        this.createTransactionItemsByInsuranceList();
        this.claimTypeSelectionChanged();
      }, err => {
        // this.showMessage('Error', 'Error fetching patient insurance');
        // this.isLoading = false;
      });
  }

  createTransactionItemsByInsuranceList() {
    let filteredByPatientInsID: DataARTransactionItemModel[] = [];
    this.dataTransactionItemsByInsuranceMaster = [];
    this.dataTransactionItemsByInsurance = [];
    this.selectedPatientInsuranceId = this.selectedInsuranceSelection;
    const selectedInsuranceDetails = this.InsuranceSelectionList.find(a => a.PatientInsuranceID === this.selectedPatientInsuranceId);

    // claim type filters
    if (this.selectedClaimType === ClaimTypeEnum.RealClaim) {
      filteredByPatientInsID = this.dataTransactionItems.filter(a => a.PatientInsuranceID === this.selectedPatientInsuranceId
        && selectedInsuranceDetails?.PatientInsurancePrimary
        && a.enumARItemStatusID === this.enumARItemStatusPosted
        && a.PostedLedgerEnumStatusID === this.enumLedgerItemStatusOutstanding
        && !this.existsInClaim(a));
    }
    else if (this.selectedClaimType === ClaimTypeEnum.SecondaryRealClaim) {
      filteredByPatientInsID = this.dataTransactionItems.filter(a => a.PatientInsuranceID === this.selectedPatientInsuranceId
        && selectedInsuranceDetails?.PatientInsurancePrimary
        && a.enumARItemStatusID === this.enumARItemStatusPosted
        // is a secondary claim made only outstanding ledger items? or also for Paid items?
        // && a.PostedLedgerEnumStatusID === this.enumLedgerItemStatusOutstanding
        && this.existsInClaim(a));
    }
    else if (this.selectedClaimType === ClaimTypeEnum.Predetermination) {
      filteredByPatientInsID = this.dataTransactionItemsPredetermination.filter(a => a.PatientInsuranceID === this.selectedPatientInsuranceId
        && selectedInsuranceDetails?.PatientInsurancePrimary);
        // && a.enumARItemStatusID !== this.enumARItemStatusPosted);
    }

    // filter out $0 insurance if needed
    if (!this.showZeroInsurance) {
      filteredByPatientInsID = filteredByPatientInsID.filter(a => a.InsuranceAmount > 0);
    }

    const transactionItems = new InsuranceTransactionItemsModel();
    transactionItems.PatientInsuranceID = this.selectedPatientInsuranceId;
    transactionItems.dataARTransactionItems = filteredByPatientInsID;
    transactionItems.InsuranceName = selectedInsuranceDetails?.InsuranceName ? (selectedInsuranceDetails?.InsuranceName.trim() !== '' ? selectedInsuranceDetails?.InsuranceName : 'Unknown') : 'Unknown';
    transactionItems.PatientInsurancePrimary = selectedInsuranceDetails?.PatientInsurancePrimary;
    this.dataTransactionItemsByInsurance.push(transactionItems);
    this.dataTransactionItemsByInsuranceMaster = this.dataTransactionItemsByInsurance;
  }

  returnPatientInsuranceDateString(PatientInsuranceID: string) {
    let sDates: string = '';

    const ins: dataPatientInsurance = this.dataPatientInsuranceList.find(a => a.PatientInsuranceID === PatientInsuranceID);
    if (ins) {
      if (ins.CoverageStart) { sDates += this.datePipe.transform(ins.CoverageStart, 'MM/dd/yyyy'); }
      sDates += '-';
      if (ins.CoverageEnd) { sDates += this.datePipe.transform(ins.CoverageEnd, 'MM/dd/yyyy'); }
    }

    return '(' + sDates + ')';
  }

  createTransactionItemsByInsuranceListSecondary() {
    this.dataTransactionItemsByInsuranceMaster = [];
    this.dataTransactionItemsByInsurance = [];

    // organize transaction items by insurance
    if (this.dataTransactionItemsSecondary && this.dataTransactionItemsSecondary.length > 0) {

      // filter array for primary insurance
      let dataTransactionItems2 = this.dataTransactionItemsSecondary.filter(o => o.PatientInsuranceOrder === 0);

      let currentPatientInsuranceID: string = '';
      dataTransactionItems2 = dataTransactionItems2.filter(a => a.PatientInsuranceName && a.PatientInsuranceName.trim() !== '' && !this.existsInClaim(a)); // <= filter out transaction items used for another claim
      this.dataTransactionItemsSecondary.forEach(a => {
          currentPatientInsuranceID = a.PatientInsuranceID;

          // if patient insurance not already added
          if (this.dataTransactionItemsByInsurance.filter(p => p.PatientInsuranceID === currentPatientInsuranceID).length === 0 || this.dataTransactionItemsByInsurance.length === 0) {
            const transactionItems = new InsuranceTransactionItemsModel();
            transactionItems.PatientInsuranceID = a.PatientInsuranceID;
            transactionItems.InsuranceName = a.PatientInsuranceName ? (a.PatientInsuranceName.trim() !== '' ? a.PatientInsuranceName : 'Unknown') : 'Unknown';
            transactionItems.dataARTransactionItems = this.dataTransactionItemsSecondary.filter(f => f.PatientInsuranceID === currentPatientInsuranceID);
            transactionItems.PatientInsurancePrimary = a.PatientInsuranceOrder === 0 ? true : false;
            this.dataTransactionItemsByInsurance.push(transactionItems);
          }
      });

      // if (this.dataTransactionItemsByInsurance.length > 0) {
      //   this.selectedInsuranceSelection = this.dataTransactionItemsByInsurance[0].PatientInsuranceID;
      // }

      this.dataTransactionItemsByInsuranceMaster = this.dataTransactionItemsByInsurance;
    }
  }

  async init() {

    this.isLoading = true;

    const promises: any[] = [
      this.getEnumsForClaims(),
      this.getDoctorsByTDOCID(),
      this.arService.getPatientClaimsTransactionItemIDs(this.PatientId).toPromise(),
      this.arService.getRealClaimDataForClaimWizard(this.PatientId).toPromise(),
      this.insuranceService.getTDOClient().toPromise(),
      this.insuranceService.getPatientInsuranceDetails(this.PatientId).toPromise(),
      this.arService.getPreDeterminationClaimDataForClaimWizard(this.PatientId).toPromise(),
    ];

    try {
      const promiseResults: any[] = await Promise.all(promises);
      this.claimTypes = promiseResults[0];
      this.doctors = promiseResults[1];
      this.patientClaims = promiseResults[2];
      this.dataTransactionItems = promiseResults[3];
      this.dataTransactionItemsSecondary = promiseResults[3];
      this.cfgTDOClient = promiseResults[4];
      this.dataPatientInsuranceList = promiseResults[5];
      this.dataTransactionItemsPredetermination = promiseResults[6];
      if(this.cfgTDOClient.length > 0){
      this.isInsuranceEstimating = this.cfgTDOClient[0].ARisEstimating;
      }
    }
    catch (err) {
      console.log(err);
      this.createMessage('Something went wrong', 'Error');
    }

    this.isLoading = false;
  }

  insuranceSelectionChanged(event) {

    // reload list
    if (event.value === Constants.emptyGuid) {
      // load all insurances
      this.dataTransactionItemsByInsurance = this.dataTransactionItemsByInsuranceMaster;
      this.isPrimarySelected = false;
    }
    else {
      const ins = this.InsuranceSelectionList.filter(a => a.PatientInsuranceID === event.value && a.PatientInsurancePrimary);
      if (ins.length > 0) {
        // primary insurance was selected
        this.isPrimarySelected = true;
      }
      else {
        // secondary insurance was selected
        this.isPrimarySelected = false;
      }

      this.createTransactionItemsByInsuranceList();
    }
  }

  isRealClaim() {
    if (this.selectedClaimType === ClaimTypeEnum.RealClaim) {
      return true;
    }
    else {
      return false;
    }
  }

  returnSelectedCount() {
    let count: number = 0;

    if (this.isPrimarySelected) {
      count = this.dataTransactionItems.filter(item => {
        return item.isSelected;
      }).length;
    }
    else {
      count = this.dataTransactionItemsSecondary.filter(item => {
        return item.isSelected;
      }).length;
    }

    return count;
  }

  getEnumsForClaims() {
    return this.arService.getEnumsForClaims().toPromise();
  }

  getDoctorsByTDOCID() {
    return this.arService.getDoctorsByTDOCID().toPromise();
  }

  getLedgerItemsForTransactions(transactionItems: DataARTransactionItemModel[]) {
    return this.arService.getLedgerItemsForTransactions(transactionItems).toPromise();
  }

  async createClaimForSelectedTransactionItems() {

    this.isLoading = true;

    // transaction items passed
    let transactionItems: DataARTransactionItemModel[] = [];
    if (this.isPrimarySelected) {
      transactionItems = this.dataTransactionItems.filter(a => a.isSelected);
    }
    else {
      transactionItems = this.dataTransactionItemsSecondary.filter(a => a.isSelected);
    }

    // check to make sure selected items all have same patientInsuranceID, providerDoctorID and LOCID
    let blValidationPassed = true;
    if (transactionItems.length > 0)
    {
      const firstItem = transactionItems[0];
      // const patientInsuranceDoctorLOCID = firstItem.PatientInsuranceID ? firstItem.PatientInsuranceID : '' + firstItem.ProviderDoctorId ? firstItem.ProviderDoctorId : '' + firstItem.LOCID ? transactionItems[0].LOCID.toString() : '';
      const patientInsuranceDoctorLOCID = this.selectedInsuranceSelection ? this.selectedInsuranceSelection : '' + firstItem.ProviderDoctorId ? firstItem.ProviderDoctorId : '' + firstItem.LOCID ? transactionItems[0].LOCID.toString() : '';
      transactionItems.forEach(a => {
        // const currentPatientInsuranceDoctorLOCID = a.PatientInsuranceID ? a.PatientInsuranceID : '' + a.ProviderDoctorId ? a.ProviderDoctorId : '' + a.LOCID ? a.LOCID.toString() : '';
        const currentPatientInsuranceDoctorLOCID = this.selectedInsuranceSelection ? this.selectedInsuranceSelection : '' + a.ProviderDoctorId ? a.ProviderDoctorId : '' + a.LOCID ? a.LOCID.toString() : '';
        if (patientInsuranceDoctorLOCID !== currentPatientInsuranceDoctorLOCID) {
          blValidationPassed = false;
        }
      });
    }

    if (blValidationPassed) {

      // only do this if creating a primary insurance claim
      if (this.isPrimarySelected) {

        // post items if needed
        let transactionItemsThatNeedPosting: DataARTransactionItemModel[] = [];
        transactionItemsThatNeedPosting = transactionItems.filter(item => {
          if (this.isTransactionPosted(item)) {
            return false;
          }
          else {
            return true;
          }
        });

        // only call post api if there are items that need posting
        if (transactionItemsThatNeedPosting.length > 0 && this.isRealClaim()) { // only post for real claims
          try {
            await this.postTransactions(transactionItemsThatNeedPosting);
          } catch (err) {
            console.log('error posting transactions');
            this.createMessage('Something went wrong', 'Error');
            return;
          }
        }

        // everything should be posted that needs to be
        try {
          let claimCreated: DataARClaimModel = new DataARClaimModel();
          const claimPromiseResults: any = await this.createClaimFromTransactions(transactionItems);
          claimCreated = claimPromiseResults;
          this.createMessage('Claims created', 'Success');
          this.openClaim(claimCreated.ARClaimID, claimCreated.enumClaimStatusID, claimCreated.enumClaimCheckStatusID);
          this.close(claimCreated);
        } catch (err) {
          console.log('error creating claims');
          this.createMessage('Something went wrong', 'Error');
        }
        this.isLoading = false;
      }
      else {
        // creating a secondary insurance claim
        try {
          let claimCreated: DataARClaimModel = new DataARClaimModel();
          const claimPromiseResults: any = await this.createSecondaryClaimFromTransactions(transactionItems);
          claimCreated = claimPromiseResults;
          this.createMessage('Claims created', 'Success');
          this.openClaim(claimCreated.ARClaimID, claimCreated.enumClaimStatusID, claimCreated.enumClaimCheckStatusID);
          this.close(claimCreated);
        } catch (err) {
          console.log('error creating claims');
          this.createMessage('Something went wrong', 'Error');
        }
        this.isLoading = false;
      }



      // // working with ledger items
      // if (this.ledgerListItems) {
      //
      //     // now all transaction items should have a matching ledger item
      //     // get list of ledger items to create claims from
      //     let ledgerItemsToClaims: DataARLedgerModel[] = [];
      //     const promiseResults: any[] = await this.getLedgerItemsForTransactions(transactionItems);
      //     ledgerItemsToClaims = promiseResults;
      //
      //     // create claims from ledger items
      //     try {
      //       let claimCreated: DataARClaimModel = new DataARClaimModel();
      //       const claimPromiseResults: any = await this.createClaimFromLedgerItems(ledgerItemsToClaims);
      //       claimCreated = claimPromiseResults;
      //       this.createMessage('Claims created', 'Success');
      //       this.openClaim(claimCreated.ARClaimID, claimCreated.enumClaimStatusID, claimCreated.enumClaimCheckStatusID);
      //       this.close(claimCreated);
      //     } catch (err) {
      //       console.log('error creating claims');
      //       this.createMessage('Something went wrong', 'Error');
      //     }
      // }
      // else {
        // working with transaction items
      //   try {
      //     let claimCreated: DataARClaimModel = new DataARClaimModel();
      //     const claimPromiseResults: any = await this.createClaimFromTransactions(transactionItems);
      //     claimCreated = claimPromiseResults;
      //     this.createMessage('Claims created', 'Success');
      //     this.openClaim(claimCreated.ARClaimID, claimCreated.enumClaimStatusID, claimCreated.enumClaimCheckStatusID);
      //     this.close(claimCreated);
      //   } catch (err) {
      //     console.log('error creating claims');
      //     this.createMessage('Something went wrong', 'Error');
      //   }
      // }
    }
    else {
      // selected items DO NOT all have same patientInsuranceID, providerDoctorID and LOCID
      this.createMessage('All items must have the same insurance, doctor, and location in order to create a claim.', 'Error');
      this.isLoading = false;
    }
  }

  createClaimForTransactionItem(transactionItem: DataARTransactionItemModel) {
    const enumClaimStatusCreated: string = ClaimStatusEnum.PendingReview;

    const dataClaim: DataARClaimModel = new DataARClaimModel();
    dataClaim.ClaimDate = new Date();
    dataClaim.PatientInsuranceID = this.PatientInsuranceID;
    dataClaim.enumClaimStatusID = enumClaimStatusCreated;

    return this.arService.saveDataClaim(dataClaim).toPromise();
  }

  postTransactions(transactionItems: DataARTransactionItemModel[]) {

    const payload = {
      LOCID: this.LOCID,
      PatientId: this.PatientId,
      transactionItems: transactionItems.map(item => {
        const itemClone = JSON.parse(JSON.stringify(item));
        item.dataARClaims = [];
        itemClone.dataARTransaction = null;
        itemClone.dataPatientCaseWorkItem = null;
        itemClone.dataDoctor = null;
        itemClone.PostDate = new Date();
        return itemClone;
      }),
      ProviderDoctorId: this.globals.currentProviderDoctorID
    };

    this.isLoading = true;
    return this.arService.postTransactionItems(payload).toPromise();
  }

  isTransactionPosted(transactionItem: DataARTransactionItemModel) {
    const enumTransactionItemStatusPosted = '00000077-1000-0000-0000-000000000002';
    if (transactionItem.enumARItemStatusID === enumTransactionItemStatusPosted) {
      return true;
    }
    else {
      return false;
    }
  }

  getLedgerForPatient(PatientId: string) {
    const promise = new Promise((resolve, reject) => {
      this.arService.getLedgerForPatient(PatientId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  close(payload) {
    this.dialogRef.close(payload);
  }

  createClaimFromTransactions(transactionItems: DataARTransactionItemModel[]) {
    const claimCreationObj = new CreateClaimsModel();
    claimCreationObj.ClaimDate = new Date();
    claimCreationObj.PatientInsuranceID = transactionItems[0].PatientInsuranceID;
    claimCreationObj.PatientID = this.globals.currentPatientId;
    claimCreationObj.ProviderDoctorID = transactionItems[0].ProviderDoctorId;
    claimCreationObj.LOCID = transactionItems[0].LOCID;
    claimCreationObj.transactionItems = transactionItems;
    claimCreationObj.enumClaimTypeID = this.selectedClaimType;
    claimCreationObj.DoctorARLocID = null; // need to get this somehow to assign it to claim we are about to create
    claimCreationObj.ledgerItems = null;
    return this.arService.createClaimFromTransactions(claimCreationObj).toPromise();
  }

  createSecondaryClaimFromTransactions(transactionItems: DataARTransactionItemModel[]) {
    const claimCreationObj = new CreateClaimsModel();
    claimCreationObj.ClaimDate = new Date();
    claimCreationObj.PatientInsuranceID = this.selectedInsuranceSelection; // this is secondary insurance selected
    claimCreationObj.PatientID = this.globals.currentPatientId;
    claimCreationObj.ProviderDoctorID = transactionItems[0].ProviderDoctorId;
    claimCreationObj.LOCID = transactionItems[0].LOCID;
    claimCreationObj.transactionItems = transactionItems;
    claimCreationObj.enumClaimTypeID = this.selectedClaimType;
    claimCreationObj.DoctorARLocID = null;
    claimCreationObj.ledgerItems = null;
    return this.arService.createClaimFromTransactions(claimCreationObj).toPromise();
  }

  createClaimFromLedgerItems(ledgerItems: DataARLedgerModel[]) {
    const claimCreationObj = new CreateClaimsModel();
    claimCreationObj.ClaimDate = new Date();
    claimCreationObj.PatientInsuranceID = ledgerItems[0].dataARTransactionItem.PatientInsuranceID;
    claimCreationObj.ProviderDoctorID = ledgerItems[0].dataARTransactionItem.ProviderDoctorId;
    claimCreationObj.DoctorARLocID = ledgerItems[0].DoctorARLocId;
    claimCreationObj.LOCID = ledgerItems[0].LOCID;
    claimCreationObj.ledgerItems = ledgerItems;
    claimCreationObj.enumClaimTypeID = this.selectedClaimType;
    return this.arService.createClaimFromLedgerItems(claimCreationObj).toPromise();
  }

  editDetailForTransaction(transactionItem: DataARTransactionItemModel, key: string) {
    transactionItem[key] = true;

    if (key === 'DATA_ENABLE_TOOTH_EDIT') {
      this.openToothPickerForTransactionItem(transactionItem);
    }
    else if (key === 'DATA_ENABLE_CODE_EDIT') {
      this.openCodePickerForTransaction(transactionItem);
    }
  }

  openToothPickerForTransactionItem(transactionItem: DataARTransactionItemModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'dialog';
    dialogConfig.data = new ToothPickerConfigModel();
    dialogConfig.data.isMultiSelect = false;
    const dialogRef = this.dialog.open(ToothPickerComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(async result => {

      if (!result) {
        return;
      }

      transactionItem.ToothID = result[0].toothModel.ToothId;
      transactionItem.Notation = result[0].toothModel.Name.replace('Tooth-', '');

      // try {
      //   const saveTransItem = await this.saveTransactionItem(transactionItem);
      // } catch (err) {
      //   console.log('err');
      // }

    }, err => {
    });
  }

  openCodePickerForTransaction(transactionItem: DataARTransactionItemModel) {
    // open window
    const dialogRef = this.dialog.open(ArCreateTransactionComponent, {
      width: '800px',
      height: '650px',
      data: {
        PatientId: this.PatientId,
        isCodeEditSingle: true,
        procedureCode: transactionItem.Code,
      }
    });

    // window closed
    dialogRef.afterClosed().subscribe(async result => {

      if (!result) {
        return;
      } else {
        // update procedure details
        if (result.length === 1) {
          transactionItem.Code = result[0].Code;
          transactionItem.Description = result[0].Description;
        }
      }
    }, err => {
    });
  }

  getDoctorById(doctorId: string) {
    let doctorName = 'Doctor name unknown';
    this.doctors.forEach(doctor => {
      if (doctor.DoctorId === doctorId) {
        doctorName = this.returnSalutation(doctor.enumSalutationID) + doctor.FirstName + ' ' + doctor.LastName;
      }
    });

    return doctorName;
  }

  returnSalutation(enumValue: string) {

    if (enumValue) {
      enumValue = enumValue.toUpperCase();
      if (enumValue === SalutationEnum.Dr) {
        return 'Dr. ';
      }
      else if (enumValue === SalutationEnum.Prof) {
        return 'Prof. ';
      }
      else if (enumValue === SalutationEnum.Mr) {
        return 'Mr. ';
      }
      else {
        return '';
      }
    } else {
      return '';
    }
  }

  openClaim(ARClaimId: string, enumClaimStatusId: string, enumClaimCheckStatusId: string) {

    const config = new MatDialogConfig();
    config.width = '900px';
    config.height = '675px';
    config.data = {
      ARClaimID: ARClaimId,
      enumClaimStatusID: enumClaimStatusId,
      numClaimCheckStatusID: enumClaimCheckStatusId,
    };
    config.panelClass = 'dialog';
    const reportViewer = this.dialog.open(ClaimViewComponent, config);
  }

  existsInClaim(dataARTransactionItem: DataARTransactionItemModel) {
    // if transaction item is already made into a claim for patient's primary insurance, it cannot be selected
    const patientClaim = this.patientClaims.find(a =>
      a.ARTransactionItemID === dataARTransactionItem.ARTransactionItemID
      && a.enumClaimStatusID !== ClaimStatusEnum.Canceled
      && a.InsuranceOrder === 0
    );

    if (patientClaim && this.isPrimarySelected) {
      return true;
    }
    else {
      return false;
    }
  }

  getClaimNumber(dataARTransactionItem: DataARTransactionItemModel) {
    // if transaction item is already made into a claim for patient's primary insurance, it cannot be selected
    const patientClaim = this.patientClaims.find(a =>
      a.ARTransactionItemID === dataARTransactionItem.ARTransactionItemID
      && a.InsuranceOrder === 0
    );

    if (patientClaim) {
      return patientClaim.TDOClaimNumber.toString();
    }
    else {
      return '';
    }
  }

  claimTypeSelectionChanged() {
    this.createTransactionItemsByInsuranceList();

    // this.dataTransactionItemsByInsurance.forEach(a => {
    //   if (this.selectedClaimType === ClaimTypeEnum.RealClaim) {
    //     a.dataARTransactionItems = a.dataARTransactionItems.filter(b => b.enumARItemStatusID === this.enumARItemStatusPosted);
    //   }
    //   else {
    //     a.dataARTransactionItems = a.dataARTransactionItems.filter(b => b.enumARItemStatusID !== this.enumARItemStatusPosted);
    //   }
    // });
  }

  onClickSelectAll(event)  {

    this.dataTransactionItemsByInsurance.forEach(d => {
        d.dataARTransactionItems.forEach(i => {
          i.isSelected = event.checked;
        });

    });
  }

  onShowZeroInsurance($event: any) {
    this.createTransactionItemsByInsuranceList();

    // this.InsuranceSelectionList = [];
    // this.ngOnInit();
  }

  protected readonly ClaimTypeEnum = ClaimTypeEnum;
}
